export default __webpack_public_path__ + "static/media/slider_mob_1.cbd281c5.png";